import React from 'react';
import CheckboxComponent from 'shared/components/CheckboxComponent';

const Castellation = (props) => {
  const name = 'castellation';

  const {
    parameters,
    onChangeParameter,
    groupName,
    className,
    label,
    required,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.checked ? '1' : '0');

  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={label}
      checked={parameters[name] === '1'}
      onChange={onChange}
      required={required}
      groupName={groupName}
      className={className} />
  );
};

Castellation.defaultProps = {
  label: 'Castellated Vias',
};

export default Castellation;
